import request from '../request'

/**
 * 协同系统-项目执行-签章 相关接口
 */


/**
 * 上传签章文件
 * @param {string} stampType - 签章类型（路径参数）
 * @param {FormData} data - 文件数据
 */
export function uploadStampFile(stampType, data) {
    return request({
        url: `/project-service/cosys/stamp/${stampType}/upload`,
        method: 'POST',
        data
    })
}

/**
 * 增加签章
 * @param {Object} data - 签章数据
 */
export function addStamp(data) {
    return request({
        url: '/project-service/cosys/stamp/add',
        method: 'POST',
        data
    })
}

/**
 * 查询签章详情
 * @param {string|number} id - 签章ID
 */
export function getStampDetail(id) {
    return request({
        url: `/project-service/cosys/stamp/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 查询签章列表
 * @param {Object} params - 查询参数
 */
export function getStampList(params) {
    return request({
        url: '/project-service/cosys/stamp/list',
        method: 'GET',
        params
    })
}

/**
 * 编辑签章
 * @param {Object} data - 签章数据
 */
export function updateStamp(data) {
    return request({
        url: '/project-service/cosys/stamp/update',
        method: 'POST',
        data
    })
}

/**
 * 查询未过期的出图章列表
 * @param {Object} params - 查询参数
 */
export function getValidDesignStampList(params) {
    return request({
        url: '/project-service/cosys/stamp/valid/design/list',
        method: 'GET',
        params
    })
}

/**
 * 查询未过期的注册章列表
 * @param {Object} params - 查询参数
 */
export function getValidRegisterStampList(params) {
    return request({
        url: '/project-service/cosys/stamp/valid/register/list',
        method: 'GET',
        params
    })
}